import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])
export const month = [
  { label: '01', value: '01' },
  { label: '02', value: '02' },
  { label: '03', value: '03' },
  { label: '04', value: '04' },
  { label: '05', value: '05' },
  { label: '06', value: '06' },
  { label: '07', value: '07' },
  { label: '08', value: '08' },
  { label: '09', value: '09' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' }
]

export default {
  'gjahr': { title: '年度', type: 'year', equation: all },
  'monat': { title: '月度', type: 'select', equation: all, dictionary: 'monat', dictionaryVal: month },
  'wlybrand': { title: '存货分类', type: 'select', equation: all, dictionary: 'A0019' },
  'wlybrand_txt': { title: '存货分类' },
  'plan_type': { title: '计划类型', describe: true, type: 'select', equation: all, dictionary: 'A0002' },
  'customer_type': { title: '客户类型', describe: true, type: 'select', equation: all, dictionary: 'A0009' },
  'sal_center': { title: '战区', describe: true, type: 'select', equation: all, dictionary: 'sale' },
  'zzfld00003e': { title: '基地', describe: true, type: 'year', equation: all, dictionary: 'base' },
  'trs_customer': { title: '订单客户编码', type: 'dialog', equation: all, dialog: { component: 'ClientSelect', title: '客户选择' }},
  'cust_name': { title: '订单客户名称', type: 'input', equation: all },
  'create_name': { title: '操作人', type: 'input', equation: all },
  'erdat': { title: '创建日期', type: 'date', equation: all },
  'datum': { title: '生效日期', type: 'date', equation: all },
  'mdate': { title: '失效日期', type: 'date', equation: all },
  'status': { title: '生效状态', describe: true },
  'remark': { title: '备注' }
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanChangeTheaterReport.js